<template>
  <div class="animationload" :class="{ 'animationload-inline': inline }">
    <div class="osahanloading"></div>
    <p v-if="text" class="loading-text">{{ text }}</p>
  </div>
</template>

<script>
  export default {
    name: 'spinner',
    props: {
      /**
       * Optional caption under the spinner. Worth setting when the wait is long
       * enough, or has enough distinct phases, that "something is happening" is
       * not an answer on its own.
       */
      text: {
        type: String,
        default: '',
      },
      /**
       * Renders in the content flow instead of masking the whole page. Use it
       * inside a panel or a modal, where a full-screen overlay would hide the
       * very thing the spinner belongs to.
       */
      inline: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped>
  .animationload {
    background-color: #fff;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
  }

  /* Undoes the full-page masking so the block occupies its own space. The ring
     runs to 60px past centre and the caption to 95px, so 220px holds both. */
  .animationload-inline {
    background-color: transparent;
    height: 220px;
    left: auto;
    position: relative;
    top: auto;
    width: auto;
    z-index: auto;
  }

  .osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
  }

  .loading-text {
    color: #777;
    font-size: 16px;
    left: 0;
    margin: 75px 0 0 0;
    padding: 0 15px;
    position: absolute;
    text-align: center;
    top: 50%;
    width: 100%;
  }

  .osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
  }

  @keyframes osahanloading {
    0% {
      transform: rotate(0deg);
    }
    50% {
      background: #85d6de none repeat scroll 0 0;
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// Spinner.vue?c61ed4a6